// The ONE Pro feature set both upgrade surfaces render in the copy-test variant
// arm (lib/billing/upgrade-copy-experiment.ts).
//
// Why it lives here rather than in either modal: the QA copy test's second
// finding was that the $1-trial modal and the direct-upgrade modal advertised
// DIFFERENT Pro features, which made the trial read as a lesser product instead
// of full Pro at a reduced entry price. A single exported list is the only way
// that can't drift back apart — both modals import this, so a bullet added for
// one is added for both.
//
// Every claim here is checked against the plan catalog, not written freehand:
//   • "Unlimited projects (Free caps at 3)" — PLANS.free.projectsLimit is 3 and
//     paid tiers are 1000 (lib/plans.ts); "Unlimited" is the established
//     user-facing wording for that in lib/pricing/plan-comparison.ts ("3" vs
//     "Unlimited") and lib/pricing/credit-tiers.ts. Named FIRST because it is
//     the concrete cap an active free builder actually hits, and it was absent
//     from both modals before this test.
//   • "Accept payments in your app"       — PLANS.pro.acceptPayments === true.
//   • "Custom domain …"                   — PLANS.pro.customDomain === true.
//   • "Remove Panda branding"             — PLANS.pro.removeBranding === true.
//   • "Premium templates + credit rollover" — PLAN_TIERS.pro.features lists
//     "Premium templates"; rollover is the rated flow's own Pro bullet
//     ("Unused credits roll over, never wasted"). This describes PRO's monthly
//     credits. On the trial modal the separate $1 trial-credit line carries its
//     own terms (trial credits expire with the trial) so the two never blur.

import { PLANS } from "@/lib/plans";

/**
 * Free-plan project cap, for the "N/3 projects used" trigger chip and the
 * "(Free caps at N)" bullet. Read from the catalog rather than hardcoded so a
 * repricing of Free can't leave either claiming a limit we no longer apply.
 */
export const FREE_PROJECT_CAP = PLANS.free.projectsLimit;

export const PRO_BENEFITS_VARIANT: readonly string[] = [
  `Unlimited projects (Free caps at ${FREE_PROJECT_CAP})`,
  "Accept payments in your app",
  "Custom domain — drop the Panda subdomain",
  "Remove Panda branding",
  "Premium templates + credit rollover",
];
